import { render, staticRenderFns } from "./QuestionsTypeEdit.vue?vue&type=template&id=3a8f8d73&scoped=true&"
import script from "./QuestionsTypeEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f8d73",
  null
  
)

export default component.exports